/**
 * @module Reducers.StudentProfile
 *
 */
import { RequestError } from "typedefs";
import { StudentProfileAction } from "app/actions/scheduling/studentProfile";
import { StudentProfileModel } from "app/models/scheduling/StudentProfileModel";

export type StudentProfileState = {
  data: StudentProfileModel | null;
  error: RequestError | null;
  pending: boolean;
};

const initialState: StudentProfileState = {
  data: null,
  error: null,
  pending: true,
};

export default function listReducer(
  state = initialState,
  action: StudentProfileAction
): StudentProfileState {
  switch (action.type) {
    case "@studentProfile.fetch.pending":
      return { ...state, error: null, pending: true };
    case "@studentProfile.fetch.success":
      return { ...state, data: action.payload, pending: false };
    case "@studentProfile.fetch.error":
      return { ...state, error: action.payload, pending: false };
    case "@studentProfile.clear":
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
}
